import React from "react";

function HealthDashboardIcon({ stroke = "#344054" }) {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.75 9.75H16.75L13.75 18.75L7.75 0.75L4.75 9.75H0.75"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default HealthDashboardIcon;
